import React, { useEffect, useState } from "react";
import { Card, CardBody, Col, Container, Form, Input, Row } from "reactstrap";
import { useParams, useNavigate } from "react-router-dom";
import { get } from "helpers/api_helper";
import { PageSubHeader } from "components/CommonLayouts/PageSubHeader";
import Footer from "components/VerticalLayout/Footer";
import * as api from "../../constants/api_constants";

function ViewCustomer() {
  const [customerData, setCustomerData] = useState({
    company: "",
    vatNumber: "",
    website: "",
    phone: "",
    primaryContactName: "",
    primaryContactEmail: "",
    primaryContactPhone: "",
    primaryContactDesignation: "",
    paymentTerms: "",
    currency: "",
    country: "",
    province: "",
    zipcode: "",
    city: "",
    address: "",
  });

  const { customerId } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    fetchCustomerData();
  }, [customerId]);

  const fetchCustomerData = async () => {
    try {
      const response = await get(api.GET_CUSTOMER_BY_ID(customerId));
      const custData = response?.customerPageResponse?.data[0];
      // console.log(custData);
      if (custData) {
        setCustomerData({
          company: custData.companyName || "",
          vatNumber: custData.vat || "",
          website: custData.website || "",
          phone: custData.phone || "",
          primaryContactName: custData.primaryContactName || "",
          primaryContactEmail: custData.email || "",
          primaryContactPhone: custData.primaryPhone || "",
          primaryContactDesignation: custData.designation || "",
          paymentTerms: custData.paymentTerms || "",
          currency: custData.currency || "",
          country: custData.country || "",
          province: custData.province || "",
          zipcode: custData.zipCode || "",
          city: custData.city || "",
          address: custData.address || "",

        });
      }
    } catch (error) {
      console.error("Error fetching customer data:", error);
    }
  };

  return (
    <>
      <div className="page-content">
        <Container fluid={true} style={{ padding: "0px", gap: "10px" }}>
          <PageSubHeader
            heading={"View Customer"}
            routePath={"Home"}
            pageName={"Customer Details"}
          />
          <Row className="p-4">
            <Col>
              <Card>
                <CardBody>
                  <Form className="row g-3 py-2">
                    <Row className="card-group">
                                          <Col xs={12} className="card-header">
                                            <p className="form-header">Customer Information</p>
                                          </Col>
                    <Row className="justify-content-start">
                      <Col md={4} className="mb-3">
                        <label className="col-form-label">Company Name</label>
                        <Input
                          type="text"
                          className="form-control"
                          value={customerData.company}
                          disabled
                        />
                      </Col>
                      <Col md={4} className="mb-3">
                        <label className="col-form-label">
                          VAT Number/Company Registration Number
                        </label>
                        <Input
                          type="text"
                          className="form-control"
                          value={customerData.vatNumber}
                          disabled
                        />
                      </Col>

                      <Col md={4} className="mb-3">
                        <label className="col-form-label">Website</label>
                        <Input
                          type="text"
                          className="form-control"
                          value={customerData.website}
                          disabled
                        />
                      </Col>
                      <Col md={4} className="mb-3">
                        <label className="col-form-label">
                          Primary Contact Name
                        </label>
                        <Input
                          type="text"
                          className="form-control"
                          value={customerData.primaryContactName}
                          disabled
                        />
                      </Col>
                      <Col md={4} className="mb-3">
                        <label className="col-form-label">
                          Primary Contact Email
                        </label>
                        <Input
                          type="email"
                          className="form-control"
                          value={customerData.primaryContactEmail}
                          disabled
                        />
                      </Col>
                      <Col md={4} className="mb-3">
                        <label className="col-form-label">
                          Primary Contact Phone Number
                        </label>
                        <Input
                          international
                          disabled
                          value={customerData.primaryContactPhone}
                          className="form-control d-flex"
                        />
                      </Col>
                      <Col md={4} className="mb-3">
                        <label className="col-form-label">Designation</label>
                        <Input
                          type="text"
                          className="form-control"
                          value={customerData.primaryContactDesignation}
                          disabled
                        />
                      </Col>
                      <Col md={4} className="mb-3">
                        <label className="col-form-label">Country</label>
                        <Input
                          type="text"
                          className="form-control"
                          value={customerData.country}
                          disabled
                        />
                      </Col>
                      <Col md={4} className="mb-3">
                        <label className="col-form-label">Currency</label>
                        <Input
                          type="text"
                          className="form-control"
                          value={customerData.currency}
                          disabled
                        />
                      </Col>
                      <Col md={4} className="mb-3">
                        <label
                          htmlFor="paymentTerms"
                          className="col-form-label"
                        >
                          Payment Terms (Days)
                        </label>
                        <Input
                          id="paymentTerms"
                          name="paymentTerms"
                          type="text"
                          className="form-control"
                          placeholder="Payment Terms"
                          value={customerData.paymentTerms}
                          disabled
                        />
                      </Col>

                      <Col md={4} className="mb-3">
                        <label className="col-form-label">Province</label>
                        <Input
                          type="text"
                          className="form-control"
                          value={customerData.province}
                          disabled
                        />
                      </Col>

                      <Col md={4} className="mb-3">
                        <label className="col-form-label">City</label>
                        <Input
                          type="text"
                          className="form-control"
                          value={customerData.city}
                          disabled
                        />
                      </Col>
                      <Col md={4} className="mb-3">
                        <label className="col-form-label">Zip Code</label>
                        <Input
                          type="text"
                          className="form-control"
                          value={customerData.zipcode}
                          disabled
                        />
                      </Col>
                      <Col md={4} className="mb-3">
                        <label className="col-form-label">Address</label>
                        <Input
                          type="textarea"
                          className="form-control"
                          value={customerData.address}
                          disabled
                          rows="3"
                        />
                      </Col>
                    </Row>
                    </Row>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        <Footer
          saveText="View Billing and Shipping Information"
          save={() => navigate(`/view-ShippingBilling/${customerId}`)}
          buttons={[
            {
              text: "Edit Customer",
              color: "primary",
              onClick: () => navigate(`/add-customer/${customerId}`),
            },
          ]}
          showBackConfirmation={false}
        />
      </div>
    </>
  );
}

export default ViewCustomer;
